import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_PROCESS_STEPS_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseProcessSteps($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        isReleasable
        processSteps {
          variant
          status
        }
      }
    }
  }
`);
